import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  count: 0,
  templatePlayers: [],
  userPlayers: [],
  templateId: '5abe100fd212fe0535c72546',
  stats: {
    nAge: '0,00',
    nHeight: '0,00',
    nWeight: '0,00',
    nCompetition: '0,0'
  },
  competition: {
    tName: '',
    tUrlPicture: ''
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/results/index.js